import { SVGICON } from '../../constant/theme';

function LogoutPage(props) {

  function onLogout() {
    if (props?.$store?.persona === _enum.ROUTE_PERSONAS.connector) {
      console.log("Connector Logout", props);
      const resolve = () => {
        console.log('logout', "DESTROY_SESSION");
        app?.props?.store("auth", false);
        app?.props?.store("user", false);
        app?.props?.store("persona", "");
        localStorage.clear();
        if (props?.$store?.persona === _enum.ROUTE_PERSONAS.connector) {
          props.navigate("/open/connector/login");
        } else if (props?.$store?.persona === _enum.ROUTE_PERSONAS.agent) {
          props.navigate("/open/agent/login");
        } else {
          props.navigate("/open/login");
        }
      }
      resolve();
    } else {
      const resolve = () => {
        console.log('logout', "DESTROY_SESSION");
        app?.props?.store("auth", false);
        app?.props?.store("user", false);
        app?.props?.store("persona", "");
        localStorage.clear();
        if (props?.$store?.persona === _enum.ROUTE_PERSONAS.connector) {
          props.navigate("/open/connector/login");
        } else if (props?.$store?.persona === _enum.ROUTE_PERSONAS.agent) {
          props.navigate("/open/agent/login");
        } else {
          props.navigate("/open/login");
        }
      }
      resolve();
    }
  }
  return (
    <>
      <button className="dropdown-item ai-icon ms-1 logout-btn" onClick={onLogout}>
        {SVGICON.Logout} {" "}
        <span className="ms-2">Logout </span>
      </button>
    </>
  )
}

export default constore(LogoutPage);